<template>
  <div class="setup-guide">
    <p class="guide-title">How to complete setup in {{ platformLabel }}</p>

    <div v-for="step in steps" :key="step.number" class="guide-step">
      <div class="guide-number">{{ step.number }}</div>
      <div class="guide-content">
        <p class="guide-step-title" v-html="step.title"></p>
        <p class="guide-step-desc">{{ step.description }}</p>
      </div>
    </div>

    <div v-if="settingsImage" class="guide-reference">
      <p class="guide-reference-label">Reference — {{ platformLabel }} plugin settings page:</p>
      <div class="guide-reference-image">
        <img :src="settingsImage" :alt="platformLabel + ' plugin settings page'">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShoplazzaSetupGuide',
  props: {
    platform: {
      type: String,
      default: '',
    },
    platformLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    settingsImage () {
      if (this.platform === 'shoplazza') {
        return require('@/assets/images/external/shoplazza.png')
      }
      // Shopify 设置页图到位后，在这里换成 require('@/assets/images/external/shopify.png')
      return ''
    },
    steps () {
      const name = this.platformLabel
      return [
        {
          number: 1,
          title: `Open ${name} App Settings`,
          description: 'Click the button on the left to open the Pagsmile Card Payments plugin settings page in a new window.',
        },
        {
          number: 2,
          title: 'Paste <span class="mono">merNo</span>',
          description: `Copy the merNo (App ID) from the left panel and paste it into the "merNo" field in ${name}.`,
        },
        {
          number: 3,
          title: 'Paste <span class="mono">sign key</span>',
          description: `Copy the Sign Key from the left panel and paste it into the "sign key" field in ${name}.`,
        },
        {
          number: 4,
          title: 'Save & Done',
          description: `Click Save in ${name} to finish connecting your store to Pagsmile.`,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.setup-guide {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
}

.guide-title {
  margin: 0;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(30, 58, 138, 0.6);
}

.guide-step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.guide-number {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-top: 2px;
  border-radius: 50%;
  background: $blue-600;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

.guide-content {
  flex: 1;
}

.guide-step-title {
  margin: 0 0 2px;
  font-size: 14px;
  font-weight: 600;
  color: $blue-900;

  ::v-deep .mono {
    padding: 0 4px;
    border-radius: 4px;
    background: $blue-100;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-weight: 600;
  }
}

.guide-step-desc {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
  color: $blue-700;
}

.guide-reference {
  margin-top: 4px;
}

.guide-reference-label {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 500;
  color: $blue-600;
}

.guide-reference-image {
  overflow: hidden;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  background: $white;

  img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}
</style>
